import script from "./BirthPayoff.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthPayoff.vue?vue&type=script&setup=true&lang=js"

import "./BirthPayoff.vue?vue&type=style&index=0&id=1cb7f432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb7f432"]])

export default __exports__